// ABOUTME: Gray pencil/edit icon with underline component
// ABOUTME: Supports className, size, and color customization

interface IconProps {
  className?: string
  size?: number
  color?: string
}

export const PencilGrayIcon = ({ className = "", size = 16, color = "#707784" }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M1.6001 11.5314V13.2001C1.6001 13.421 1.77919 13.6001 2.0001 13.6001H3.66873C3.8809 13.6001 4.08439 13.5158 4.23441 13.3658L10.7506 6.84962L8.35058 4.44962L1.83441 10.9658C1.68439 11.1158 1.6001 11.3193 1.6001 11.5314Z"
      fill={color}
    />
    <path
      d="M12.4647 5.13545L11.608 5.99215L9.20801 3.59215L10.0647 2.73546C10.4708 2.32931 11.1294 2.32931 11.5354 2.73545L12.4647 3.66468C12.8708 4.07082 12.8708 4.72931 12.4647 5.13545Z"
      fill={color}
    />
    <path
      d="M8.00555 12.0001C7.56374 12.0001 7.20557 12.3583 7.20557 12.8001C7.20557 13.2419 7.56374 13.6001 8.00555 13.6001H13.6001C14.042 13.6001 14.4001 13.2419 14.4001 12.8001C14.4001 12.3583 14.042 12.0001 13.6001 12.0001H8.00555Z"
      fill={color}
    />
  </svg>
)
